import { CompaniesNames } from '../classes/Magento/Constants'

export const getCheckoutUrlBasedOnCompany = (companyName) => {
  switch (companyName) {
    case (CompaniesNames.Vitel):
      return '/onestepcheckout/'
    case (CompaniesNames.Head):
      return '/onestepcheckout/'
    default:
      return '/checkout/'
  }
}
